<template><div><h1 id="ruckzahlung-erfassen" tabindex="-1"><a class="header-anchor" href="#ruckzahlung-erfassen"><span>Rückzahlung erfassen</span></a></h1>
<p>Rückzahlung manuell erfassen — Rückzahlung in manuellen Buchungen erfassen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Manuelle Korrektur von eigentlichen Doppelzahlungen. Die Fakturanummer der Doppelzahlung sollte angegeben werden, dann wird der Betrag automatisch eingetragen und die Doppelzahlung &quot;rückgängig&quot; gemacht. Die Konto-Kostenstelle-Kostenträger-Informationen werden aus der Faktura übernommen. Wird keine Fakturanummer angegeben oder findet das System keine entsprechende Buchung, verbucht es ein Guthaben</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Rückzahlung (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Rückahlung gebucht wird</dd>
<dt>Fakturanummer</dt>
<dd>Auswahl einer bestehenden Fakturamnummer</dd>
<dt>Betrag</dt>
<dd>Rückzahlungsbetrag eintragen</dd>
<dt>Währung</dt>
<dd>Fremdwährung</dd>
<dt>Valutadatum</dt>
<dd>Valutadatum der Buchung</dd>
<dt>Mandant</dt>
<dd>Der <a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> wird nur eingetragen, wenn er auf Grund der Konteneingabe nicht eindeutig feststellbar ist</dd>
<dt>Konto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
<dt>Zahlungsnummer</dt>
<dd>Frei definierbare Zahlungsnummer</dd>
</dl>
<h3 id="mogliche-situationen-beim-erfassen-einer-ruckzahlung" tabindex="-1"><a class="header-anchor" href="#mogliche-situationen-beim-erfassen-einer-ruckzahlung"><span>Mögliche Situationen beim Erfassen einer Rückzahlung</span></a></h3>
<p>Bei einer Rückzahlung muss der Betrag, das Datum, die Fakturanummer und das Konto eingegeben werden. Die Währung der Rückzahlung hängt von der Währung des Habenkontos und der Währung der Faktura ab. Falls keine Faktura mit eingegebener Fakturanummer bei der Adresse existiert, so ist einzig die Währung des Habenkontos massgebend.</p>
<table>
<thead>
<tr>
<th>Währung der Rückzahlung</th>
<th>Währung der Faktura</th>
<th>Auswirkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Landeswährung</td>
<td>Landeswährung</td>
<td>Der Fremdbetrag und die Fremdwährung müssen leer bleiben. Allfälliges freies Guthaben auf dem Landeswährungskonto wird automatisch zur Deckung der Rückzahlung verwendet.</td>
</tr>
<tr>
<td>Landeswährung</td>
<td>Fremdwährung</td>
<td>Der Fremdbetrag muss grösser Null sein und der Landeswährungsbetrag wird mit dem (zum Valutadatum) aktuellen Kurs umgerechnet. Zur Deckung der Rückzahlung wird nur das allfällige freie Guthaben in der Fremdwährung gebraucht. Das Guthaben in der Landeswährung bleibt unverändert.</td>
</tr>
<tr>
<td>Landeswährung</td>
<td>keine Faktura</td>
<td>In diesem Fall verhält sich das System gleich, wie wenn die Faktura in der Landeswährung wäre.</td>
</tr>
<tr>
<td>Fremdwährung</td>
<td>Landeswährung</td>
<td>Der Fremdbetrag muss grösser Null sein. Der Landeswährungsbetrag wird mit dem (zum Valutadatum) aktuellen Kurs automatisch umgerechnet. Allfälliges freies Guthaben in Landeswährung wird zur Deckung der Rückzahlung verwendet.</td>
</tr>
<tr>
<td>Fremdwährung</td>
<td>Fremdwährung</td>
<td>Der Fremdbetrag muss grösser Null sein. Der Landeswährungsbetrag wird mit dem (zum Valutadatum) aktuellen Kurs automatisch umgerechnet. Allfälliges freies Guthaben in Fremdwährung wird zur Deckung der Rückzahlung verwendet.</td>
</tr>
<tr>
<td>Fremdwährung</td>
<td>keine Faktura</td>
<td>In diesem Fall verhält sich das System gleich, wie wenn die Faktura in der Fremdwährung wäre.</td>
</tr>
</tbody>
</table>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


